import styled from 'styled-components';

export const FilterContainer = styled.div`
  padding: 0 1rem;
`;

export const SearchInputContainer = styled.div`
  display: flex;
  column-gap: 1rem;
  align-items: flex-end;
  padding-bottom: 1rem;

  & > div {
    width: 16.875rem;
  }

  & > button {
    width: 10.75rem;
  }
`;

export const CreateNewMockupButtonContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.gray8};
  padding: 1rem;
`;

export const CreateNewMockupButton = styled.div`
  display: flex;
  justify-content: flex-end;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0.5rem;
`;
